import React from 'react'
import EditSquareIcon from "../../../assets/icons/EditSquareIcon"
import SilverButton from "../SilverButton"
import "./styles.css"

const SIZE_MAP = {
    xs: { btn: 32, icon: 18 },
    sm: { btn: 40, icon: 22 },
    md: { btn: 48, icon: 26 },
    lg: { btn: 56, icon: 30 },
}

const EditButton = ({
                        onClick,
                        size = 'xs',
                        variant = 'default',
                        styles = {},
                    }) => {
    const { btn, icon } = SIZE_MAP[size] || SIZE_MAP.xs

    return (
        <SilverButton
            width={`${btn}px`}
            height={`${btn}px`}
            onClick={onClick}
            className={`common-action-button edit-button--${size}`}
            styles={styles}
            variant={variant}
        >
            <EditSquareIcon width={icon} height={icon} />
        </SilverButton>
    )
}

export default EditButton



// WEBPACK FOOTER //
// ./src/components-new/buttons/actions/EditButton.jsx